import React, { useEffect, useState } from "react";
import axios from "axios";
import WalletConnect from "./WalletConnect";
import Leaderboard from "./Leaderboard";

const DonationBic = () => {
  const [balanceKAS, setBalanceKAS] = useState(0);
  const [valueKASInUSD, setValueKASInUSD] = useState(0);
  const goalKAS = 70000;

  useEffect(() => {
    const fetchBalanceKAS = async () => {
      try {
        const response = await axios.get(
          "https://api.kaspa.org/addresses/kaspa%3Aqp3t6d9gznfatvh0nvnql89uzrpqpc43zt7j0p6meqprrrnt2td6285ehy72y/balance"
        );
        const balanceInKAS = response.data.balance / 1e8;
        setBalanceKAS(balanceInKAS);

        const kasPriceResponse = await axios.get(
          "https://api.kaspa.org/info/price?stringOnly=false"
        );
        const kasPriceInUSD = kasPriceResponse.data.price;

        const valueInUSD = balanceInKAS * kasPriceInUSD;
        setValueKASInUSD(valueInUSD);
      } catch (error) {
        console.error("Erreur lors de la récupération du solde KAS :", error);
      }
    };

    fetchBalanceKAS();
  }, []);

  const progressPercentageKAS = Math.min((balanceKAS / goalKAS) * 100, 100);

  const address =
    "kaspa:qp3t6d9gznfatvh0nvnql89uzrpqpc43zt7j0p6meqprrrnt2td6285ehy72y";

  const handleCopy = () => {
    navigator.clipboard.writeText(address).then(
      () => {
        alert("Address copied to clipboard!");
      },
      (err) => {
        console.error("Could not copy text: ", err);
      }
    );
  };

  return (
    <div id="donation" className="donation bic section">
      <div className="container mx-auto">
        <div className="progressbar_container">
          <h3 className="progressbar_title">Biconomy listing</h3>
          <div className="progressbar_bg bg-gray-300 rounded-full h-9 mb-4">
            <div
              className="progressbar_fill text-xs font-medium text-center text-blue-100 flex items-center justify-center h-full rounded-full"
              style={{ width: `100%` }}
            >
              100%
            </div>
          </div>
          <div className="progressbar_goal">
            <div className="progressbar_goal_item">
              <span>Goal</span>
              <p>{goalKAS.toLocaleString()} KAS ($8,000)</p>
            </div>
            <div className="progressbar_goal_item">
              <span>Koontribution</span>
              <p>70 000 KAS ($8 000)</p>
            </div>
          </div>
        </div>

        <div className="sendKas_container">
          <h3 className="progressbar_title">Send KAS to this address:</h3>

          <div className="sendKas">
            <span>{address}</span>
            <svg
              onClick={handleCopy}
              height="32px"
              viewBox="0 -960 960 960"
              width="32px"
              fill="undefined"
            >
              <path d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DonationBic;
